<template>
  <div class="editGallery">
    <div class="topBar">
      <div class="subTitle"><i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"></i>编辑相册</div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        编辑相册
      </div>
      <div class="table">
        <div class="form">
          <div class="row">
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">相册名称:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="name"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">相册封面:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <input
                    type="file"
                    name="image"
                    accept="image/png, image/jpeg, image/jpg"
                    @change="getImage($event)"
                    style="margin-bottom: 10px"
                  >
                  <div class="notice">图片必须为jpg或png合适，且大小不能超过5mb</div>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">相册描述:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input type="textarea" v-model="info"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row" align="center">
            <div class="grid-content input">
              <button class="button" @click="submit()">提交</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "editGallery",
  data() {
    return { serve: this.$store.state.serve,
      name: "",
      info: "",
      image: null,
      galleryId: this.$route.params.id,
      token : this.$cookies.get('token'),
      username : this.$cookies.get('username')
    };
  },
  created() {
    this.$store.state.topActiveId = 2;
    this.$store.state.leftTitle = "图片库";
    var that = this;
    this.axios
      .get(this.serve+"/admin/change_photo_album", {
        params: { id: this.galleryId , username : this.username ,token : this.token }
      })
      .then(function(res) {
        that.name = res.data[0].name;
        that.info = res.data[0].info;
      })
      .catch(function(err) {
        alert("操作失败");
      });
  },
  mounted() {},
  methods: {
    getImage(e) {
      this.image = e.target.files[0];
    },
    submit() {
      if (this.name == "") {
        alert("未填写相册名称");
        return;
      }
      let formData = new FormData();
      formData.append("id", this.galleryId);
      formData.append("name", this.name);
      formData.append("cover", this.image);
      formData.append("info", this.info);
      formData.append("username", this.username);
      formData.append("token", this.token);
    
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };

      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      var that = this;

      this.axios
        .post(this.serve+"/admin/update_photo_album", formData, config)
        .then(function(res) {console.log(res);
          if(res.data.status == 'success'){
            loading.close();
            that.$message({
              type:"success",
              message : '编辑相册成功'
            })
            that.$router.push({
              path:'/admin/gallery'
            })
          }else if(res.data.status == 'error'){
            loading.close();
            that.$message.error(res.data.msg)
          }
        })
        
    }
  }
};
</script>
<style lang="scss">
.editGallery {
  background: #f5f5f5;
  color: #333;
  height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
  .input {
    width: 100%；;
  }
  textarea {
    height: 300px;
  }
  .form-title {
    background-color: #eee;
    border: 1px solid #ddd;
    padding: 10px;
  }
  .table {
    background-color: #fff;
  }
  .row {
    margin-bottom: 20px;
  }
  .form {
    width: 450px;
    margin: 0 auto;
    padding: 20px 0;
  }
  .label {
    line-height: 40px;
  }
  .notice {
    font-size: 13px;
    color: #666;
  }
}
</style>